export enum Empresa {
  Taxi2424 = 'Taxi2424',
  EcoGroupRivera = 'EcoGroupRivera',
}

export type BookingOriginInput = 'google-place' | 'street-json';
export type BookingStreetDeptCode = 'UY-RV' | 'UY-CO' | 'UY-SJ' | 'UY-CA' | 'UY-MA';

export interface GooglePlaceBounds {
  north: number;
  south: number;
  east: number;
  west: number;
}

export interface CompanyConfig {
  protocolHttps: string;
  portWsHttps: string;
  serverUrl: string;
  adminServerUrl: string;
  companyRut: string;
  folderRutFotoChofer: string;
  companyName: string;
  appRoleName: string;
  appLogoDisplay: string;
  appPoiCompany: string;
  mapQuestKey: string;
  pubNubPublishKey: string;
  pubNubSubscribeKey: string;
  pubNubSecretKey: string;
  latDefault: number;
  lngDefault: number;
  latAddressDefault: number;
  lngAddressDefault: number;
  enableFare: boolean;
  enableZones: boolean;
  bookingOriginInput: BookingOriginInput;
  bookingShowSavedAddressFields: boolean;
  bookingSavedAddressFieldsReadonly: boolean;
  bookingStreetDeptCode?: BookingStreetDeptCode;
  googlePlaceBounds?: GooglePlaceBounds;
  googlePlaceStrictBounds?: boolean;
}

// Cambiar solo este valor para levantar la configuracion completa de la empresa.
export const ACTIVE_COMPANY = Empresa.EcoGroupRivera;

export const COMPANY_CONFIGS: { [key in Empresa]: CompanyConfig } = {
  [Empresa.Taxi2424]: {
    protocolHttps: 'https://',
    portWsHttps: ':443',
    serverUrl: 'webcoretaxi24.fleet.uy',
    adminServerUrl: 'webcoretaxi24.fleet.uy',
    companyRut: '215503960013',
    folderRutFotoChofer: '215503960013/',
    companyName: 'Taxi 2424',
    appRoleName: 'Operador',
    appLogoDisplay: 'assets/img/logo24.png',
    appPoiCompany: '/assets/poi/poicolonia.json',
    mapQuestKey: 'm1CgugVnmKtoAPeIWiVoNFCIlotNQbd3',
    pubNubPublishKey: 'pub-c-25169dc3-bcbd-4fff-a6d0-a1873e5b903b',
    pubNubSubscribeKey: 'sub-c-f0184dd0-934b-11e4-b395-02ee2ddab7fe',
    pubNubSecretKey: 'sec-c-MTRkOWVmMmUtODIyOC00YjJlLWI1NjYtYzAwMzg3NjdlZTg5',
    latDefault: -34.462699,
    lngDefault: -57.838826,
    latAddressDefault: -34.462699,
    lngAddressDefault: -57.838826,
    enableFare: true,
    enableZones: true,
    bookingOriginInput: 'google-place',
    bookingShowSavedAddressFields: true,
    bookingSavedAddressFieldsReadonly: true,
    googlePlaceBounds: {
      north: -34.35,
      south: -34.55,
      east: -57.75,
      west: -57.95,
    },
    googlePlaceStrictBounds: false,
  },
  [Empresa.EcoGroupRivera]: {
    protocolHttps: 'https://',
    portWsHttps: ':443',
    serverUrl: 'webcoreecotaxi.fleet.uy',
    adminServerUrl: 'webcoreecotaxi.fleet.uy',
    companyRut: '140191640013',
    folderRutFotoChofer: '140191640013/',
    companyName: 'EcoGroup',
    appRoleName: 'Operador',
    appLogoDisplay: 'assets/img/logecotaxirivera.png',
    appPoiCompany: '/assets/poi/poirivera.json',
    mapQuestKey: '7qHhkR1iyeObbMQgEV63YMNJeM7orTj3',
    pubNubPublishKey: 'pub-c-25169dc3-bcbd-4fff-a6d0-a1873e5b903b',
    pubNubSubscribeKey: 'sub-c-f0184dd0-934b-11e4-b395-02ee2ddab7fe',
    pubNubSecretKey: 'sec-c-MTRkOWVmMmUtODIyOC00YjJlLWI1NjYtYzAwMzg3NjdlZTg5',
    latDefault: -30.8999187,
    lngDefault: -55.5399061,
    latAddressDefault: -30.8999187,
    lngAddressDefault: -55.5399061,
    enableFare: false,
    enableZones: true,
    bookingOriginInput: 'street-json',
    bookingShowSavedAddressFields: true,
    bookingSavedAddressFieldsReadonly: false,
    bookingStreetDeptCode: 'UY-RV',
  },
};

export const ACTIVE_COMPANY_CONFIG = COMPANY_CONFIGS[ACTIVE_COMPANY];
